import { ICON_BASE_PATH, IMAGE_BASE_PATH } from "@/app/utils/config";

type DialogTechnicalProps = {
  open: boolean;
  close: () => void;
};

const DialogTechnical = ({ open, close }: DialogTechnicalProps) => {
  if (!open) return null;

  return (
    <div className="gx-technicalmodal-overlay">
      <div className="gx-technicalmodal-container">
        <button
          className="gx-dialog-close-button gx-technicalmodal-close"
          onClick={close}
        >
          <img
            className="gx-icon-primary"
            src={`${ICON_BASE_PATH}close.svg`}
            alt="Close"
          />
        </button>

        <div className="grid grid-cols-12 gap-2">
          <div className="col-span-12">
            <div className="gx-consents-technicalerror">
              <img src={`${IMAGE_BASE_PATH}technicalerror.svg`} alt="Warning" />
            </div>
          </div>

          <div className="col-span-12 mb-2.5">
            <div className="gx-dialog-title-h2">
              <h2 className="gx-h2-26-l">
                Technical{" "}
                <span className="gx-h2-26-b">Error</span>
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DialogTechnical;
